export const CloseButton = ({ closeToast }: any) => (
  <i
    className=" flex items-center  border-l border-[#EBEFF3] px-2 not-italic text-[#FFFFFF] p-xs-regular-dim1"
    onClick={closeToast}
  >
    OK
  </i>
)
